var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccescircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.291504,
    y: 0.410156,
    width: 58.4777,
    height: 58.4777,
    rx: 29.2388,
    fill: "white",
    fillOpacity: 0.11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.748361,
    y: 0.867013,
    width: 57.5639,
    height: 57.5639,
    rx: 28.782,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 0.913713
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_632_1399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8611 32.967C36.7674 32.967 40.7589 28.9435 40.7589 23.9982C40.7589 19.0528 36.7674 15.0293 31.8611 15.0293C26.9549 15.0293 22.9634 19.0527 22.9634 23.9981C22.9634 28.9435 26.9549 32.967 31.8611 32.967ZM29.002 26.7969C29.2608 26.4012 29.7914 26.2902 30.1871 26.5491C30.7636 26.9262 30.9811 26.9609 31.7418 26.9556C32.4843 26.9507 32.9152 26.3973 33.0012 25.8851C33.0431 25.636 33.0592 25.0276 32.3052 24.7611C31.4209 24.4485 30.5158 24.0911 29.8862 23.5973C29.2565 23.1034 28.9682 22.2509 29.1338 21.3725C29.3133 20.4202 29.9775 19.6621 30.8674 19.3941C30.8755 19.3917 30.8834 19.3898 30.8914 19.3874V19.0629C30.8914 18.5901 31.2747 18.2068 31.7475 18.2068C32.2203 18.2068 32.6036 18.5901 32.6036 19.0629V19.3335C33.1851 19.4723 33.5911 19.7383 33.756 19.8615C34.1347 20.1446 34.2122 20.6811 33.9291 21.0598C33.646 21.4385 33.1096 21.5161 32.7309 21.2329C32.5554 21.1017 32.0706 20.8198 31.3612 21.0335C30.9468 21.1584 30.8394 21.5672 30.8163 21.6896C30.771 21.9299 30.8218 22.1552 30.9428 22.25C31.3793 22.5923 32.1649 22.8955 32.8758 23.1467C34.1867 23.6101 34.9157 24.8246 34.6897 26.1689C34.5788 26.8285 34.247 27.4405 33.7553 27.8922C33.4204 28.1999 33.0306 28.4193 32.6036 28.5446V28.9333C32.6036 29.4061 32.2203 29.7894 31.7475 29.7894C31.2747 29.7894 30.8914 29.4061 30.8914 28.9333V28.63C30.3379 28.5629 29.8732 28.3898 29.2497 27.9819C28.8541 27.7231 28.7432 27.1925 29.002 26.7969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1563 35.8438H16.2042C15.7314 35.8438 15.3481 36.2271 15.3481 36.6998V43.4111C15.3481 43.8839 15.7314 44.2672 16.2042 44.2672H18.1563V35.8438H18.1563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4627 35.7834C41.8581 34.1788 39.2472 34.1788 37.6427 35.7834L35.0782 38.3479L34.0271 39.399C33.6023 39.8238 33.0261 40.0625 32.4253 40.0625H27.3142C26.8526 40.0625 26.4553 39.7077 26.4336 39.2466C26.4104 38.7543 26.8027 38.3479 27.2899 38.3479H32.4851C33.5296 38.3479 34.4356 37.6042 34.6151 36.5753C34.6564 36.339 34.6779 36.096 34.6779 35.8481C34.678 35.3745 34.2942 34.9901 33.8206 34.9901H30.974C30.0437 34.9901 29.1503 34.5681 28.2045 34.1212C27.2124 33.6526 26.1865 33.168 24.987 33.0882C23.9379 33.0183 22.8864 33.1332 21.8615 33.4291C20.7642 33.746 19.9754 34.7209 19.8797 35.8465C19.8761 35.8462 19.8724 35.8462 19.8687 35.8459V44.2637L34.6179 44.2678C35.632 44.2678 36.5854 43.8728 37.3026 43.1557L43.4625 36.9958C43.7975 36.6611 43.7975 36.1182 43.4627 35.7834Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_1399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.2388,
    height: 29.2388,
    fill: "white",
    transform: "translate(14.9106 15.0293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccescircle);
export default __webpack_public_path__ + "static/media/Accescircle.1c8917e7d8410983a3a36ccc1d7f0baf.svg";
export { ForwardRef as ReactComponent };